import { useState, useCallback } from "react";
import type { OptimisticConversationMessagesModel } from "../util/optimisticMessage.utils";
import type { ConversationMessagesModel } from "@certa/queries/queries/comms";

export const useOptimisticMessages = () => {
  const [optimisticMessages, setOptimisticMessages] = useState<
    (OptimisticConversationMessagesModel | ConversationMessagesModel)[]
  >([]);

  const addOptimisticMessage = useCallback(
    (message: OptimisticConversationMessagesModel) => {
      setOptimisticMessages(prev => [...prev, message]);
    },
    []
  );

  const removeOptimisticMessage = useCallback((messageId: string) => {
    setOptimisticMessages(prev =>
      prev.filter(msg => msg.kryptonId.toString() !== messageId)
    );
  }, []);

  const replaceOptimisticMessage = useCallback(
    (optimisticId: string, actualMessage: ConversationMessagesModel) => {
      setOptimisticMessages(prev =>
        prev.map(msg =>
          msg.kryptonId.toString() === optimisticId ? actualMessage : msg
        )
      );
    },
    []
  );

  return {
    optimisticMessages,
    addOptimisticMessage,
    removeOptimisticMessage,
    replaceOptimisticMessage
  };
};
